/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 784
// module chunks = 1